import React, { forwardRef } from "react";
import { CommandIcon } from "./icons";

interface CommandItemProps {
  title: string;
  description?: string;
  onSelect: () => void;
  isSelected: boolean;
  index: number;
}

const CommandItem = forwardRef<HTMLDivElement, CommandItemProps>(
  ({ title, description, onSelect, isSelected }, ref) => (
    <div
      ref={ref}
      className={`group flex cursor-pointer items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-all duration-200 ease-out ${
        isSelected
          ? "bg-gradient-to-r from-blue-50 to-indigo-50 text-blue-900 shadow-sm ring-1 ring-blue-100"
          : "text-gray-700 hover:bg-gray-50/70 hover:shadow-sm"
      }`}
      onClick={onSelect}
    >
      <div
        className={`flex h-8 w-8 items-center justify-center rounded-lg transition-all duration-200 ${
          isSelected
            ? "bg-white text-blue-600 shadow-sm"
            : "bg-gray-100/80 text-gray-500 group-hover:bg-gray-100 group-hover:text-gray-700"
        }`}
      >
        <CommandIcon title={title} size={18} />
      </div>
      <div className="min-w-0 flex-1">
        <div
          className={`truncate font-medium leading-tight ${
            isSelected ? "text-blue-900" : "text-gray-900"
          }`}
        >
          {title}
        </div>
        {description && (
          <div
            className={`mt-0.5 truncate text-xs leading-tight ${
              isSelected ? "text-blue-700/70" : "text-gray-500"
            }`}
          >
            {description}
          </div>
        )}
      </div>
    </div>
  ),
);

CommandItem.displayName = "CommandItem";
export default CommandItem;
